module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"map-toggler:hide":"Скрыть карту","map-toggler:show":"Показать карту"},"en":{"map-toggler:hide":"Hide map","map-toggler:show":"Show map"}}')
  delete Component.options._Ctor
}
